<template>
  <JsonForms
    :data="data"
    :renderers="usedRenderers"
    :schema="schema"
    :uischema="uischema"
    :ajv="ajv"
    @change="onChange"
    :validation-mode="validationMode"
  />
</template>

<script setup lang="ts" generic="T">
  import { JsonSchema, UISchemaElement, ValidationMode } from '@jsonforms/core';
  import { JsonForms, JsonFormsChangeEvent } from '@jsonforms/vue';
  import { provide } from 'vue';
  import { defaultStyles } from './styles';
  import renderers from './controls';
  import * as vanillarRenderers from '@jsonforms/vue-vanilla';
  import Ajv from 'ajv';
  import addFormats from 'ajv-formats';
  import errors from 'ajv-errors';

  defineProps<{
    data: T;
    schema: JsonSchema;
    uischema: UISchemaElement | undefined;
    validationMode?: ValidationMode;
  }>();

  const ajv = new Ajv({
    allErrors: true,
    verbose: true,
    strict: false,
  });
  addFormats(ajv);
  errors(ajv);
  const usedRenderers = Object.freeze([
    ...renderers,
    ...vanillarRenderers.layoutRenderers,
    ...vanillarRenderers.arrayRenderers,
    ...vanillarRenderers.labelRenderers,
  ]);

  const emit = defineEmits<{
    (event: 'change', value: T): void;
    (event: 'error', error: Pick<JsonFormsChangeEvent, 'errors'>): void;
  }>();

  function onChange(event: JsonFormsChangeEvent) {
    emit('error', event as Pick<JsonFormsChangeEvent, 'errors'>);
    emit('change', event.data);
  }
  provide('styles', defaultStyles);
</script>

<style></style>
